import { useCallback } from 'react';

import { Link, LinkSize, LinkTarget, SupportIcon } from '@dreryk/react-components';

import { patientPortalTranslationKeys } from '../../translations';

type WidgetHelpCenterLinkProps = {
   readonly installationManualLink: string;
};

export const WidgetHelpCenterLink = (props: WidgetHelpCenterLinkProps): JSX.Element => {
   const navigate = useCallback(() => {
      window.open(props.installationManualLink, LinkTarget.BLANK);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
   return (
      <Link
         testId={'widgetHelpCenterLink'}
         onClick={navigate}
         size={LinkSize.NORMAL}
         label={patientPortalTranslationKeys.widget.helpCenterManual}
         icon={<SupportIcon />}
      />
   );
};
